import { render, staticRenderFns } from "./OrderConfirmation-Content.vue?vue&type=template&id=65e4e657&scoped=true&"
import script from "./OrderConfirmation-Content.vue?vue&type=script&lang=js&"
export * from "./OrderConfirmation-Content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e4e657",
  null
  
)

export default component.exports